// extracted by mini-css-extract-plugin
module.exports = {"container":"Fun_container__1AKT8 ResponsiveBackground_background__1FkTW"};